import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

export function createExportContext<T>(displayName: string) {
  const Context = createContext<T | undefined>(undefined);
  Context.displayName = displayName;

  const useContextHook = (): T => {
    const context = useContext(Context);
    if (!context) throw new Error(`use${displayName} must be used within ExportProvider.`);
    return context;
  };

  const Provider = ({ children, value }: { children: ReactNode; value: T }) => (
    <Context.Provider value={value}>{children}</Context.Provider>
  );

  return { useContextHook, Provider } as const;
}
